var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('div', {
    staticClass: "mb-40"
  }, [_c('v-chip-group', {
    staticClass: "mb-8"
  }, [_c('v-chip', {
    attrs: {
      "outlined": "",
      "label": "",
      "color": "primary"
    }
  }, [_c('span', {
    staticClass: "font-size-14"
  }, [_vm._v(" " + _vm._s(_vm.program._employees.length.format()) + "명 참여 ")])]), _c('v-chip', {
    attrs: {
      "outlined": "",
      "label": "",
      "color": "secondary"
    }
  }, [_c('span', {
    staticClass: "font-size-14"
  }, [_vm._v(" " + _vm._s(_vm.program._employers.length.format()) + "개 기업 참여 ")])])], 1), _c('h5', {
    staticClass: "tit--lg mb-8"
  }, [_vm._v(" " + _vm._s(_vm.program.subject) + " ")]), _c('p', {
    staticClass: "page-text--lg primary--text"
  }, [_vm._v(" " + _vm._s(_vm.program.host.name) + " ")])], 1), _c('div', [_c('v-row', {
    staticClass: "ma-n4"
  }, [_c('v-col', {
    staticClass: "pa-4",
    attrs: {
      "cols": "12"
    }
  }, [_c('expo-program-apply', _vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on,
          loading = _ref.loading,
          isNext = _ref.isNext;
        return [isNext ? [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "large": "",
            "block": "",
            "outlined": "",
            "color": "grey-d"
          }
        }, 'v-btn', Object.assign({}, attrs, {
          disabled: _vm.disabled,
          loading: loading
        }), false), on), [_c('span', {
          staticClass: "grey--text"
        }, [_vm._v(" 프로그램 참여정보 ")])])] : [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "large": "",
            "block": "",
            "color": "primary"
          }
        }, 'v-btn', Object.assign({}, attrs, {
          disabled: _vm.disabled,
          loading: loading
        }), false), on), [_vm._v(" 신청하기 ")])]];
      }
    }])
  }, 'expo-program-apply', {
    program: _vm.program
  }, false))], 1), _c('v-col', {
    staticClass: "pa-4"
  }, [_c('v-btn', _vm._b({
    attrs: {
      "large": "",
      "outlined": "",
      "block": "",
      "color": "grey-d"
    },
    on: {
      "click": _vm.share
    }
  }, 'v-btn', {
    disabled: _vm.disabled,
    loading: _vm.loading
  }, false), [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("공유하기")]), _c('v-icon', {
    staticClass: "ml-10 grey--text",
    attrs: {
      "size": "21px"
    }
  }, [_vm._v("mdi-share-variant-outline")])], 1)], 1), _c('v-col', {
    staticClass: "pa-4"
  }, [_c('like-btn', {
    attrs: {
      "params": _vm.params__likeBtn
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var _class;
        var active = _ref2.active,
          loading = _ref2.loading,
          toggle = _ref2.toggle;
        return [_c('v-btn', _vm._b({
          attrs: {
            "large": "",
            "outlined": "",
            "block": ""
          },
          on: {
            "click": toggle
          }
        }, 'v-btn', {
          color: active ? 'yellow darken-1' : 'grey-d',
          disabled: _vm.disabled,
          loading: loading
        }, false), [_c('v-layout', {
          class: (_class = {}, _class['grey--text'] = !active, _class),
          attrs: {
            "justify-center": "",
            "align-baseline": ""
          }
        }, [_c('span', [_vm._v(" 관심행사 ")]), _c('v-icon', {
          staticClass: "ml-10",
          attrs: {
            "size": "21px"
          }
        }, [_vm._v(" " + _vm._s(active ? "mdi-bookmark" : "mdi-bookmark-outline") + " ")])], 1)], 1)];
      }
    }])
  })], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }